export default __webpack_public_path__ + "static/media/simple-swaps.9ce1d092.png";